export default __webpack_public_path__ + "static/media/zoom-in.e5823638.svg";